import { codeOf, dayLabel, groupByDay, relativeDay, timeLabel } from "@/lib/airtime";
import type { UpcomingEpisode } from "@/lib/airtime";
import { posterUrl } from "@/lib/poster";

const SOON_MS = 2 * 86_400_000;

function Skeleton() {
  return (
    <ul className="rows">
      {[0, 1, 2, 3].map((n) => (
        <li key={n} className="skeleton">
          <span className="skeleton-poster" />
          <span className="skeleton-lines">
            <span className="skeleton-line" />
            <span className="skeleton-line short" />
          </span>
        </li>
      ))}
    </ul>
  );
}

function Row({ episode, onOpen }: { episode: UpcomingEpisode; onOpen: () => void }) {
  const poster = posterUrl(episode.showPoster, "row");
  return (
    <li className="row">
      <button type="button" className="row-fg" onClick={onOpen}>
        {poster === null ? (
          <span className="poster" />
        ) : (
          <img className="poster" src={poster} alt="" loading="lazy" decoding="async" />
        )}
        <span className="meta">
          <span className="show-name">{episode.showTitle}</span>
          <span className="ep-title">{episode.title || "Title to be announced"}</span>
        </span>
        <span className="ep-right">
          <span className="code-lg">{codeOf(episode)}</span>
          <span className="left-count">
            {episode.airsAt === null ? "" : timeLabel(episode.airsAt)}
          </span>
        </span>
      </button>
    </li>
  );
}

export function Upcoming({
  episodes,
  loading,
  onOpen,
}: {
  episodes: readonly UpcomingEpisode[];
  loading: boolean;
  onOpen: (simklId: number) => void;
}) {
  const groups = groupByDay(episodes);
  if (loading && groups.length === 0) return <Skeleton />;

  if (groups.length === 0) {
    return (
      <div className="empty">
        <strong>Nothing scheduled</strong>
        <p>None of the shows you follow have an announced episode yet.</p>
      </div>
    );
  }

  const now = new Date();
  return (
    <>
      {groups.map((group) => (
        <section key={group.key}>
          <h2
            className={`day-head${group.date.getTime() - now.getTime() < SOON_MS ? " soon" : ""}`}
          >
            <span className="day-name">{dayLabel(group.date, now)}</span>
            <span className="day-when">{relativeDay(group.date, now)}</span>
          </h2>
          <ul className="rows">
            {group.episodes.map((episode) => (
              <Row
                key={`${episode.showId}-${codeOf(episode)}`}
                episode={episode}
                onOpen={() => {
                  onOpen(episode.showId);
                }}
              />
            ))}
          </ul>
        </section>
      ))}
    </>
  );
}
